export function CorporateLicensePage() {
  return (
    <article className="legal-document">
      <h1>Termos de Licenciamento Corporativo e Institucional (B2B)</h1>
      <p className="text-muted">
        LONDON SIM GESTÃO DE DOCUMENTOS LTDA (Datasci Editora) — CNPJ 22.390.588/0001-70
      </p>

      <section>
        <h2>1. Escopo da Licença Corporativa</h2>
        <p>
          A licença institucional para empresas e organizações contratantes (<em>tenants</em>) é de caráter{" "}
          <strong>não exclusivo, intransferível e estritamente restrita ao quantitativo de licenças ou cotas de acesso</strong>{" "}
          contratadas no respectivo plano corporativo.
        </p>
      </section>

      <section>
        <h2>2. Modalidades de Licenciamento</h2>
        <p>A concessão corporativa opera através de uma ou mais das seguintes modalidades parametrizadas no sistema:</p>
        <ul>
          <li>
            <strong>Por Título / Obra (Per Title):</strong> número fixo de licenças vinculadas a obras específicas do catálogo
            para consumo exclusivo de colaboradores indicados.
          </li>
          <li>
            <strong>Catálogo Definido (Defined Catalog):</strong> acesso irrestrito a um conjunto curado de obras da editora
            durante o período contratual.
          </li>
          <li>
            <strong>Cota Global (Global Quota):</strong> franquia de acessos compartilhada entre os colaboradores da empresa,
            com dedução automática à medida que novos colaboradores ativam obras.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Direitos Autorizados de Uso Interno</h2>
        <p>A contratação institucional autoriza:</p>
        <ul>
          <li>Download e armazenamento digital dos arquivos em dispositivos corporativos autorizados;</li>
          <li>Distribuição interna exclusiva aos colaboradores, colaboradores terceirizados e funcionários ativos da empresa;</li>
          <li>Impressão parcial para fins de estudo interno, treinamentos corporativos e capacitação de equipes.</li>
        </ul>
      </section>

      <section>
        <h2>4. Vedações e Restrições Absolutas</h2>
        <p>É expressamente vedado à empresa contratante e a seus prepostos:</p>
        <ul>
          <li>Revenda, sublicenciamento comercial ou cessão onerosa a terceiros fora da organização;</li>
          <li>Disponibilização pública em intranets abertas, sites corporativos acessíveis ao público externo ou redes sociais;</li>
          <li>Modificação, descompilação ou criação de obras derivadas a partir do conteúdo técnico das publicações.</li>
        </ul>
      </section>

      <section>
        <h2>5. Término da Vigência Contratual e Retenção de Dados</h2>
        <p>
          Ao término do prazo de vigência estipulado em contrato (ou em caso de não renovação):
        </p>
        <ul>
          <li>O portal corporativo (<code>/t/:tenantSlug</code>) e o painel administrativo do tenant serão imediatamente suspensos;</li>
          <li>Novos downloads e alocações de licenças aos colaboradores serão bloqueados;</li>
          <li>
            Em conformidade com as diretrizes de governança da Datasci Editora e a LGPD, os registros e dados de colaboradores
            serão preservados para fins de auditoria pelo período regulamentar de <strong>36 (trinta e seis) meses</strong>, sendo
            posteriormente expurgados.
          </li>
        </ul>
      </section>
    </article>
  );
}
